import { render, staticRenderFns } from "./ImprintPage.vue?vue&type=template&id=57594dd7&"
import script from "./ImprintPage.vue?vue&type=script&lang=ts&"
export * from "./ImprintPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports